document.addEventListener("DOMContentLoaded", () => {
  const sticky = document.getElementById("StickyATC");
  const variantInput = document.querySelector('input[name="id"]');

  if (!sticky) return;

  function initObserver() {
    const originalButton = document.querySelector('button[name="add"]');

    if (!originalButton) {
      setTimeout(initObserver, 300);
      return;
    }

    const stickyButton = sticky.querySelector(".sticky-atc__button");

    if (stickyButton) {
      stickyButton.addEventListener("click", () => {
        const text = stickyButton.querySelector(".sticky-atc__button-text");

        stickyButton.classList.add("loading");

        if (text) {
          text.textContent = "AGREGANDO...";
        }

        setTimeout(() => {
          originalButton.click();

          stickyButton.classList.remove("loading");
          stickyButton.classList.add("added");

          if (text) {
            text.innerHTML = "&#10003; AGREGADO";
          }

          setTimeout(() => {
            stickyButton.classList.remove("added");

            if (text) {
              text.textContent = "RECLAMAR OFERTA";
            }
          }, 1800);
        }, 150);
      });
    }

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];

      if (entry.isIntersecting) {
        sticky.classList.remove("visible");
        document.body.classList.remove("sticky-atc-visible");
      } else {
        sticky.classList.add("visible");
        document.body.classList.add("sticky-atc-visible");
      }
    }, {
      threshold: 0.1
    });

    observer.observe(originalButton);

    updateStickyVariant();

    if (variantInput) {
      new MutationObserver(updateStickyVariant)
        .observe(variantInput, {
          attributes: true,
          attributeFilter: ["value"]
        });
    }
  }

  initObserver();

  initStickyVariants();
});

function formatStickyATCMoney(cents) {
  const amount = Number(cents) / 100;

  return "$" + new Intl.NumberFormat("es-CO", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true
  }).format(amount);
}

function updateStickyVariant() {
  const input = document.querySelector('input[name="id"]');

  if (!input || !window.StickyATCProduct) {
    return;
  }

  const variantId = Number(input.value);
  const variant = window.StickyATCProduct.variants.find(v => v.id === variantId);

  if (!variant) {
    return;
  }

  const currentPrice = document.getElementById("StickyATCCurrent");
  const stickyButtonPrice = document.querySelector('[id^="sticky-atc-price-"]');
  const comparePrice = document.getElementById("StickyATCCompare");
  const saveBadge = document.getElementById("StickyATCSave");
  const image = document.getElementById("StickyATCImage");
  const title = document.getElementById("StickyATCTitle");

  if (currentPrice) {
    currentPrice.textContent = formatStickyATCMoney(variant.price);
  }

  if (stickyButtonPrice) {
    stickyButtonPrice.textContent = formatStickyATCMoney(variant.price) + " •";
  }

  if (comparePrice) {
    if (variant.compare_at_price > variant.price) {
      comparePrice.textContent = formatStickyATCMoney(variant.compare_at_price);
      comparePrice.style.display = "";
    } else {
      comparePrice.style.display = "none";
    }
  }

  if (saveBadge) {
    if (variant.compare_at_price > variant.price) {
      const percent = Math.round(
        (variant.compare_at_price - variant.price) / variant.compare_at_price * 100
      );

      saveBadge.textContent = `Ahorra ${percent}%`;
      saveBadge.style.display = "inline-flex";
    } else {
      saveBadge.style.display = "none";
    }
  }

  if (image) {
    image.src =
      variant.featured_image?.src ||
      variant.featured_media?.preview_image?.src ||
      image.dataset.defaultImage;
  }

  const buttons = document.querySelectorAll(".sticky-atc__variant");

  buttons.forEach(button => {
    button.classList.toggle("active", button.dataset.value === variant.option1);
  });

  if (title) {
    title.textContent = window.StickyATCProduct.title;
  }
}

function initStickyVariants() {
  const buttons = document.querySelectorAll(".sticky-atc__variant");
  const stickyImage = document.getElementById("StickyATCImage");

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      const value = button.dataset.value;
      const image = button.dataset.image;

      /* 1. Cambiar la foto del sticky */
      if (stickyImage && image) {
        stickyImage.src = image;
        stickyImage.removeAttribute("srcset");
      }

      /* 2. Marcar el color activo */
      buttons.forEach(btn => {
        btn.classList.remove("active");
      });

      button.classList.add("active");

      /* 3. Sincronizar con el selector original */
      const original = document.querySelector(`input[name="Color"][value="${value}"]`);

      if (original) {
        original.click();

        setTimeout(() => {
          updateStickyVariant();
        }, 200);
      }
    });
  });
}
